skrilla.directive('manualTransactions',function(currencyService, $stateParams) {
    return {
        templateUrl: 'directives/manualTransactions/manualTransactions.html',
        scope: {
        },
        controller: function($scope, searchService, queryService, paginationService, cacheService){
            const getTransactions = function() {
                return searchService.get("manualTransactions" + queryService.getQueryString($scope.query, $scope.pageKey)).then(function (response) {
                    $scope.manualTransactions = response.data.result;
                    cacheService.registerObject("manualTransactions", $scope.manualTransactions);
                    paginationService.setPage($scope.pageKey, paginationService.buildPage(response));
                });
            };

            const id = $stateParams["id"] || "";
            $scope.pageKey = "manualTransactions";
            $scope.manualTransactions = cacheService.getObjectOrElse("manualTransactions", []);

            $scope.reset = function () {
                $scope.query = {
                    userId: "",
                    accountId:"",
                    currencies: currencyService.getCurrencyMap(),
                    id,
                    limit: 20
                };
            };

            $scope.search = function () {
                paginationService.resetPage($scope.pageKey);
                paginationService.pageQuery(getTransactions, $scope.pageKey);
            }

            $scope.reset();
            if (id) {
                $scope.search()
            }
        }
    };
});
